import React, { useEffect, useState } from "react";
import Button from "../../extras/Button";
import Input from "../../extras/Input";
import { useDispatch, useSelector } from "react-redux";
import { editData, objectToFormData, submitData } from "../../../util/fuction";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { DangerRight } from "../../api/toastServices";

import {
  categoryAdd,
  categoryUpdate,
} from "../../../redux/slice/categorySlice";
import { permissionError } from "../../../util/Alert";
import { Box, Modal } from "@mui/material";

const CategoryDialogue = () => {
  const dispatch = useDispatch();
  const { dialogueData } = useSelector((state) => state.dialogue);
  const [imagePath, setImagePath] = useState("");
  const hasPermission = useSelector((state) => state.auth.admin.flag);
  useEffect(() => {
    if (dialogueData) {
      editData(dialogueData);
      setImagePath(dialogueData?.image);
    }
  }, [dialogueData]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!hasPermission) return permissionError();
    const addCategory = submitData(e);

    if (addCategory) {
      const formData = objectToFormData(addCategory);

      try {
        let response;
        if (dialogueData) {
          const payload = { formData, categoryId: dialogueData._id };
          response = await dispatch(categoryUpdate(payload)).unwrap();
        } else {
          response = await dispatch(categoryAdd(formData)).unwrap();
        }
        response.status
          ? dispatch(closeDialog())
          : DangerRight(response.message);
      } catch (err) {
        console.log("err", err);
        DangerRight(err.message);
      }
    }
  };

  return (
    <Modal
      open={true}
      onClose={closeDialog}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="model-style">
       <div className="model-header">
          <p className="m-0">Category</p>
        </div>
        <div className="model-body">   
          <form  id="expertForm">
            <div className="row align-items-start formBody">
              <div className="col-12 ">
                <Input
                  type={`text`}
                  id={`name`}
                  name={`name`}
                  label={`Name`}
                  placeholder={`Name`}
                  errorMessage={`Enter Name`}
                  className={"form-control"}
                />
              </div>
              <div className="col-12 ">
                <Input
                  type={`file`}
                  id={`image`}
                  name={`image`}
                  label={`Image`}
                  errorMessage={`Image is required`}
                  accept={"image/ "}
                  className={"form-control"}
                />
              </div>
            </div>
          </form>
        </div>
            <div className="model-footer">
             <div className="m-3 d-flex justify-content-end gap-2">
                <Button
                  className={`close-model-btn`}
                  text={`Cancel`}
                  type={`button`}
                  onClick={() => dispatch(closeDialog())}
                />
                <Button
                  type={`submit`}
                  onClick={(e) => handleSubmit(e)}
                  text={`Submit`}
                />
              </div>
            </div>
        
      </Box>
    </Modal>

  );
};

export default CategoryDialogue;
